import {
  PublicClientApplication,
  AuthenticationResult,
  IController,
  Configuration,
  AccountInfo,
} from '@azure/msal-browser';

class MockMsalInstance extends PublicClientApplication {
  controller: IController = {} as IController;
}

const msalMockData: MockMsalInstance = new MockMsalInstance(
  {} as Configuration
);

msalMockData.acquireTokenSilent = () =>
  Promise.resolve({} as AuthenticationResult);
msalMockData.acquireTokenPopup = () =>
  Promise.resolve({} as AuthenticationResult);
msalMockData.loginPopup = () => Promise.resolve({} as AuthenticationResult);
msalMockData.getActiveAccount = () =>
  ({
    homeAccountId: 'mock-home-account-id',
    environment: 'mock-environment',
    tenantId: 'mock-tenant-id',
    username: 'mock-username',
    localAccountId: 'mock-local-account-id',
    name: 'Mock Name',
    idToken: '123456789',
    idTokenClaims: {
      aud: 'mock-aud',
      iss: 'mock-iss',
      iat: 1616161616,
      nbf: 1616161616,
      exp: 1616161616,
      aio: 'mock-aio',
      name: 'Mock Name',
      oid: 'mock-oid',
      preferred_username: 'mock-username',
      sub: 'mock-sub',
      tid: 'mock-tid',
      uti: 'mock-uti',
      ver: 'mock-ver',
    },
  }) as AccountInfo | null;

export default msalMockData;
